'use client'
import React, {useEffect} from "react";
import classes from './MediatorCard.module.scss'
import Image from "next/image";
import RoundedButton from "@/app/components/buttons/rounded-button/RoundedButton"
import ratingIcon from '../../assets/images/icons/ratingIcon.svg';
import {useTranslation} from "react-i18next";
import {useRouter} from "next/navigation";
import {useAppContext} from "@/app/context/UserContext";
import useModal from "@/app/hooks/useModal";
import closeIcon from "@/app/assets/images/icons/closeIcon.svg";
import GetInTouch from "@/app/components/mediator-card/get-in-touch/GetInTouch";

const MediatorCard = ({item,className}) => {

    const {user} = useAppContext();
    const {t} = useTranslation();
    const {openModal, closeModal, ModalComponent} = useModal();

    if (!item) {
        return <div>Connector data is unavailable.</div>;
    }
    const router = useRouter();

    function getInitials(name) {
        const words = name.split(' ');
        const firstLetter = words.length > 0 ? words[0].charAt(0) : '';
        let secondLetter = '';
        if (words.length > 1) {
            secondLetter = words[1].charAt(0);
        }
        return firstLetter + secondLetter;
    }

    const openGetInTouchForm = () => {
        if (!user) {
            router.push('/login');
        } else {
            openModal();
        }
    }

    return (
        <div className={`${classes.card} ${className && className}`}>
            <div className={classes.userDesc}>
                <div
                    className={classes.placeholder}
                    style={{
                        backgroundImage: item.profile_photo ? `url(${item.profile_photo})` : 'none',
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                    }}
                >
                    {!item.profile_photo && <h1>{getInitials(item.name)}</h1>}
                </div>
                <div>
                <span className={classes.rating}><Image src={ratingIcon}
                                                        alt={'ratingIcon'}/><p>{(Number(item.average_rating)).toFixed(2) === 'NaN' ? t('noRatings')
                    : (Number(item.average_rating)).toFixed(2)}</p></span>
                <h3>{item.name || 'Unknown'}</h3>
                <p>{item.position}{(item.position && item.company) && ', '} {item.company}</p>
                </div>
            </div>
            {user?.id !== item.id && <div className={classes.cardFooter}>
                {/*<p>{t('from')}: <span>100€</span></p>*/}
               <RoundedButton
                    className={classes.btn}
                    type="primary"
                    onClick={openGetInTouchForm}
                >
                    {t('buttons.getInTouch')}
                </RoundedButton>
                <ModalComponent closeIcon={<Image src={closeIcon} alt={'close icon'}/>}>
                    <GetInTouch closeModal={closeModal} item={item} getInitials={getInitials}/>
                </ModalComponent>
            </div>}
        </div>
    );
}

export default MediatorCard;